module.exports = __webpack_public_path__ + "static/media/32.e50d0167.mp3";